// extracted by mini-css-extract-plugin
module.exports = {"main":"modal_main__erplU","title":"modal_title__18TBm","closeArea":"modal_closeArea__3bq97","closeIcon":"modal_closeIcon__11eqR","content":"modal_content__Vbfb_"};